import React from "react";
import "./style.css";

function Footer() {
    return <div>
        <div className="footer">
            <p>Paul Nelson 2019</p>
        </div>
    </div>
}

export default Footer;